<template>
  <div class="w-100 h-100">
    <div class="w-100 h-100 d-flex align-items-center justify-content-center" v-if="is_load">
      <loader />
    </div>
    <template v-else>
      <PosWideLayout v-if="page_design_type === 'WIDE_VIEW'" />
      <PosMobileLayout v-else />
    </template>
  </div>
</template>

<script>
  import PosMobileLayout from './layouts/PosMobileLayout.vue';
  import PosWideLayout from './layouts/PosWideLayout.vue';
  import {
    mapGetters,
    mapMutations
  } from 'vuex';
  import {
    get
  } from '@/services/index.js'
  import { applyResolvedTitle } from '../../../../utils/titleService';
  import { trackPageViewAfterDataLoaded } from '../../../../utils/analytics';

  const PRODUCT_PAGE_SIZE = 20
  const MAX_PAGE_SIZE = 100
  const PROMO_NOT_FOUND = 'promo_code not found'
  const JUMP_SETTLE_MS = 150

  export default {
    components: {
      PosMobileLayout,
      PosWideLayout
    },
    provide() {
      return {
        posContext: this
      };
    },
    data() {
      return {
        is_load: true,
        error: '',
        is_load_product_best: true,
        is_load_product_list: true,
        general_data: {},
        product_per_category: [],
        product_best: [],
        is_category_jumping: false,
        scroll_p: 0,
        category_position:{
          list: [],
          active: {}
        },
        active_image: null,
        product_detail_popup: {
          show: false,
          pos_id: '',
          product_id: ''
        }
      }
    },
    computed: {
      ...mapGetters(['getMerchant','getOutletTrxPromoCode','getMetaTitleTemplate','getOutletTrxPageModule','getOutletTrxProducts']),
      pos_code() {
        return this.$route.params.pos_code
      },
      page_design_type() {
        return (this.general_data.page_design === 'WIDE_VIEW' && !this.$is_mobile_view) ? 'WIDE_VIEW' : 'MOBILE_VIEW'
      },
      show_image(){
        let return_data = false
        if(this.general_data.slider_image && this.general_data.slider_image.length > 0) return_data = true
        return return_data
      }
    },
    mounted() {
      this.$smoothScroll('top-section')
      this.loadFirstData()
      window.addEventListener('scroll', this.updateScroll);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.updateScroll);
      clearTimeout(this.jumpSettleTimer)
    },
    methods: {
      ...mapMutations(['setTrxOutletTableNumber','setTrxOutletLockTableNumber','clearTrxOutletProduct','setTrxOutletPromoCode']),
      updateScroll() {
        this.scroll_p = window.scrollY
        if(this.is_category_jumping) this.scheduleJumpSettle()
        if(this.category_position.list.length > 0){
          let active = this.category_position.list.findIndex(x=>window.scrollY > x.position.start && window.scrollY < x.position.end)
          if(active != -1){
            this.category_position.active = this.category_position.list[active]
          }else{
            this.category_position.active = {}
          }
        }
      },
      jumpToCategory(scrollToTarget){
        // Lazy loading pauses until the scroll settles, so pages loading above the target can't push it away mid-scroll.
        this.is_category_jumping = true
        this.realignJumpTarget = scrollToTarget
        scrollToTarget('smooth')
        this.scheduleJumpSettle()
      },
      scheduleJumpSettle(){
        clearTimeout(this.jumpSettleTimer)
        this.jumpSettleTimer = setTimeout(this.settleCategoryJump, JUMP_SETTLE_MS)
      },
      settleCategoryJump(){
        this.realignJumpTarget('auto')
        this.is_category_jumping = false
        this.$nextTick(this.getActiveCategory)
      },
      setActiveImage(index){
        this.active_image = index
      },
      goToPage(page) {
        let route = {
          name: page,
          params: {
            merchant_code: this.getMerchant.code,
            pos_code: this.pos_code
          }
        }
        if(page == 'PosSearch'){
          route.query = {
            pos_id: this.general_data.id
          }
        }
        this.$router.push(route)
      },
      loadFirstData() {
        this.is_load = true
        this.error = ''
        this.setTableNumber()

        if(!(this.getOutletTrxPageModule == '' || this.getOutletTrxPageModule == 'outlet')){
          this.clearTrxOutletProduct()
        }

        Promise.all([
          this.loadGeneralData(),
        ]).catch(err => this.error = err).then(()=>{
          this.checkProductDetailQuery()
          setTimeout(()=>{
            this.getActiveCategory()
          },100)
        })
      },
      loadGeneralData() {
        return new Promise((success, fail) => {
          this.general_data = {}
          get("CORE_HOTEL", `merchant-pos/${this.pos_code}/general`, {
            merchant_id: this.getMerchant.id
          }).then(response => {
            let res = response.data
            if (res.success) {
              this.general_data = res.data
              this.$validatePage('CONCIERGE',this.general_data).then(()=>{
                applyResolvedTitle({router: this.$router, title: res.data.tagline, trackFn: () => {
                  trackPageViewAfterDataLoaded()
                }})

                this.is_load = false
                this.is_load_product_best = true
                this.is_load_product_list = true
                Promise.all([
                  this.loadProductBestList(),
                  this.loadCategoryList()
                ]).catch(err=>fail(err)).finally(()=>success())
              }).catch(err=>{
                console.log("🚀 ~ err:", err)
                fail()
              })
            } else {
              this.is_load = false
              fail(res.message)
            }
          })
        })
      },
      loadProductBestList(){
        return new Promise((success,fail)=>{
          get("CORE_HOTEL", `merchant-pos/${this.general_data.id}/best-product`,{
            merchant_id: this.getMerchant.id,
            page_size: MAX_PAGE_SIZE,
            type: 'PRODUCT',
            promo_code: this.getOutletTrxPromoCode
          }).then(response=>{
            let res = response.data
            if (res.success) {
              this.product_best = res.data
              this.is_load_product_best = false
              success()
            } else {
              if(res.message === PROMO_NOT_FOUND){
                this.setTrxOutletPromoCode('')
                this.loadProductBestList().then(()=>success()).catch(next_err=>fail(next_err)).finally(()=>this.is_load_product_best = false)
              }else{
                this.is_load_product_best = false
                fail(res.message)
              }
            }
          })
        })
      },
      loadCategoryList(){
        return new Promise((success,fail)=>{
          get("CORE_HOTEL", `merchant-pos/${this.general_data.id}/product-category`,{
            merchant_id: this.getMerchant.id,
            page_size: MAX_PAGE_SIZE
          }).then(response=>{
            let res = response.data
            if (res.success) {
              this.product_per_category = res.data.map(category=>({
                ...category,
                products: [],
                page: 0,
                has_more: true,
                is_loading_more: false
              }))
              this.is_load_product_list = false
              success()
            } else {
              this.is_load_product_list = false
              fail(res.message)
            }
          })
        })
      },
      loadMoreCategoryProducts(category){
        return this.fetchCategoryProducts(category).then(()=>this.$nextTick(this.getActiveCategory))
      },
      fetchCategoryProducts(category, is_promo_retry = false){
        if(category.is_loading_more || !category.has_more) return Promise.resolve()
        category.is_loading_more = true
        const next_page = category.page + 1
        return get("CORE_HOTEL", `merchant-pos/${this.general_data.id}/product`,{
          merchant_id: this.getMerchant.id,
          category_id: category.id,
          page: next_page,
          page_size: PRODUCT_PAGE_SIZE,
          promo_code: this.getOutletTrxPromoCode
        }).then(response=>{
          const res = response.data
          category.is_loading_more = false
          if(res.success){
            category.products = category.products.concat(res.data)
            category.page = next_page
            category.has_more = this.hasNextPage(res, next_page)
            return
          }
          if(res.message === PROMO_NOT_FOUND && !is_promo_retry){
            this.setTrxOutletPromoCode('')
            return this.fetchCategoryProducts(category, true)
          }
          category.has_more = false
        }).catch(()=>{
          category.is_loading_more = false
          category.has_more = false
        })
      },
      hasNextPage(res, page){
        if(res.last_page) return page < res.last_page
        return res.data.length === PRODUCT_PAGE_SIZE
      },
      setTableNumber(){
        let table_number = this.$route.query.table_number
        if(table_number){
          this.setTrxOutletTableNumber(table_number)
          this.setTrxOutletLockTableNumber(true)
          this.$router.replace(
            {
              query: {}
            }
          )
        }
      },
      getActiveCategory(){
        let cat_list = document.querySelectorAll(".category")
        let loop_data = Array.from(cat_list)
        this.category_position.list = loop_data.map((x,i)=>{
          let child = Array.from(x.childNodes)
          let margin_bottom = 48
          let data = {
            title: i == 0 ? 'Best Seller' : this.product_per_category[i-1].name,
            position: {
              start: x.offsetTop,
              end: x.offsetTop+x.offsetHeight+margin_bottom
            },
            target_id: i == 0 ? 'product-best' : this.product_per_category[i-1].id
          }
          return data
        })
      },
      checkProductDetailQuery() {
        if (this.$route.query.product_detail_id && this.page_design_type === 'WIDE_VIEW') {
          this.product_detail_popup = {
            show: true,
            pos_id: this.$route.query.pos_id || this.general_data.id,
            product_id: this.$route.query.product_detail_id
          }

          let query = Object.assign({}, this.$route.query);
          delete query.product_detail_id;
          delete query.pos_id;
          this.$router.replace({ query });
        }
      }
    }
  }

</script>




// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/index.vue